"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # Emoji
 * Simple Foodbomb Emoji Wrapper Component
 *
 * ## PropTypes:
 * ```js
 *  FBButton.propTypes = {
 *  content: PropTypes.string,
 *  label: PropTypes.string,
 *  className: PropTypes.string,
 *  };
 * ```
 *
 */
var Emoji = function Emoji(_ref) {
  var content = _ref.content,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    "aria-label": label || 'emoji',
    className: className
  }, content);
};

Emoji.propTypes = {
  content: _propTypes.default.string,
  label: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = Emoji;
exports.default = _default;

//# sourceMappingURL=Emoji.js.map